import { AccordionTheme, AccordionThemeClasses } from './accordion-theme';

export const getThemeClasses = (
  theme: AccordionTheme
): AccordionThemeClasses => {
  switch (theme) {
    case AccordionTheme.DEFAULT:
      return {
        backgroundColourClass: 'bg-neutral-150',
        borderColourClass: undefined
      };
    case AccordionTheme.CONVERSIONS:
      return {
        backgroundColourClass: 'bg-neutral-150',
        borderColourClass: undefined
      };
    case AccordionTheme.REVENUE:
      return {
        backgroundColourClass: 'bg-tertiary-100',
        borderColourClass: 'border-tertiary-400'
      };
    case AccordionTheme.OPPORTUNITY:
      return {
        backgroundColourClass: 'bg-primary-40',
        borderColourClass: 'border-primary-50'
      };
    default:
      return {} as AccordionThemeClasses;
  }
};
